import { utils } from '@/util';
import { AllergieDocument } from './AllergieDocument';
import { AutorisationEtablissement } from './AutorisationEtablissement';
import { Autorisations } from './Autorisations';
import { AutorisationsIndividu } from './AutorisationsIndividu';
import { ChampLibreDocument } from './ChampLibreDocument';
import { ChampLibreResultDocument } from './ChampLibreResultDocument';
import { ChampLibreResultValeurDocument } from './ChampLibreResultValeurDocument';
import { ChampLibreValeurDocument } from './ChampLibreValeurDocument';
import { Famille } from './Famille';
import { FamilleChampLibreResultDocument } from './FamilleChampLibreResultDocument';
import { HistoScolarite } from './HistoScolarite';
import { IndividuAllergieDocument } from './IndividuAllergieDocument';
import { IndividuChampLibreResultDocument } from './IndividuChampLibreResultDocument';
import { IndividuMaladieDocument } from './IndividuMaladieDocument';
import { IndividuVaccinDocument } from './IndividuVaccinDocument';
import { InformationIndividuDocument } from './InformationIndividuDocument';
import { Inscription } from './Inscription';
import { LienIndParDocument } from './LienIndParDocument';
import { MaladieDocument } from './MaladieDocument';
import { MedecinDocument } from './MedecinDocument';
import { MobiDocument } from './MobiDocument';
import { Parent } from './Parent';
import { VaccinDocument } from './VaccinDocument';
import { VieQuotidienneDocuments } from './VieQuotidienneDocument';
export class Individu extends MobiDocument {

    //Attributs from DB
    private _id: string;
    private _rev: string;
    private id: number;
    private nom: string;
    private prenom: string;
    private datenaissance: string;
    private sexe: string;
    private famille_id: number;
    private regimealimentaire_id: number;
    private typerepas_id: number;
    private medecin_id: number;
    private pai: boolean;
    private suituntraitement: boolean;
    private photodata: string;
    private portable: string;
    private email: string;


    //Attributs for Vuejs
    private displayName: string;
    private age: string;
    private regimAlimIntitule: string;
    private groupe: string;
    private groupeId: number;
    private inscription_id: number;
    private listeAutorisations: Array<Autorisations>;
    private etime:number;
    private pointages:Array<String>;
     private customDateTime: string = "";
    
    public constructor(individu: any) {
        super();
        this._id = individu._id;
        this._rev = individu._rev;
        this.id = individu.id;
        this.nom = individu.nom;
        this.prenom = individu.prenom;
        this.datenaissance = individu.datenaissance;
        this.sexe = individu.sexe;
        this.famille_id = individu.famille_id;
        this.regimealimentaire_id = individu.regimealimentaire_id;
        this.typerepas_id = individu.typerepas_id;
        this.medecin_id = individu.medecin_id;
        this.pai = individu.pai;
        this.suituntraitement = individu.suituntraitement;
        this.photodata = utils.getSrcIndividu(individu.photodata);
        this.displayName = individu.nom + " " + individu.prenom;
        this.age = "";
        this.setAgeFromDate();
        this.regimAlimIntitule = "";
        this.groupe = "";
        this.groupeId = -1;
        this.inscription_id = -1;
        this.listeAutorisations = [];
        this.portable = individu.portable;
        this.email = individu.email;
        this.pointages=new Array();
        this.etime=0;
    }

    public get_id(): string {
        return this._id;
    }

    public set_id(_id: string): void {
        this._id = _id;
    }

    public get_rev(): string {
        return this._rev;
    }

    public set_rev(_rev: string): void {
        this._rev = _rev;
    }

    public getId(): number {
        return this.id;
    }

    public setId(id: number): void {
        this.id = id;
    }

    public getNom(): string {
        return this.nom;
    }

    public setNom(nom: string): void {
        this.nom = nom;
    }

    public getPrenom(): string {
        return this.prenom;
    }

    public setPrenom(prenom: string): void {
        this.prenom = prenom;
    }

    public getDatenaissance(): string {
        return this.datenaissance;
    }

    public setDatenaissance(datenaissance: string): void {
        this.datenaissance = datenaissance;
    }

    public getSexe(): string {
        return this.sexe;
    }

    public setSexe(sexe: string): void {
        this.sexe = sexe;
    }

    public getFamille_id(): number {
        return this.famille_id;
    }

    public setFamille_id(famille_id: number): void {
        this.famille_id = famille_id;
    }

    public getRegimealimentaire_id(): number {
        return this.regimealimentaire_id;
    }

    public setRegimealimentaire_id(regimealimentaire_id: number): void {
        this.regimealimentaire_id = regimealimentaire_id;
    }

    public getTyperepas_id(): number {
        return this.typerepas_id;
    }

    public setTyperepas_id(typerepas_id: number): void {
        this.typerepas_id = typerepas_id;
    }

    public getDisplayName(): string {
        return this.displayName;
    }

    public setDisplayName(displayName: string): void {
        this.displayName = displayName;
    }

    public getAge(): string {
        return this.age;
    }

    public setAge(age: string): void {
        this.age = age;
    }

    public setAgeFromDate(): void {
        let current = utils.getCurrentTimeNow();
        let dateNaissance = utils.getDateFromString(this.getDatenaissance(), "YYYY-MM-DD")
        this.setAge(utils.getAnneDiff(dateNaissance, current));
    }

    public getRegimAlimIntitule(): string {
        return this.regimAlimIntitule;
    }

    public setRegimAlimIntitule(regimAlimIntitule: string): void {
        this.regimAlimIntitule = regimAlimIntitule;
    }

    public getMedecin_id(): number {
        return this.medecin_id;
    }

    public setMedecin_id(medecin_id: number): void {
        this.medecin_id = medecin_id;
    }

    public isPai(): boolean {
        return this.pai;
    }

    public setPai(pai: boolean): void {
        this.pai = pai;
    }

    public isSuituntraitement(): boolean {
        return this.suituntraitement;
    }

    public setSuituntraitement(suituntraitement: boolean): void {
        this.suituntraitement = suituntraitement;
    }

    public getGroupe(): string {
        return this.groupe;
    }

    public setGroupe(groupe: string): void {
        this.groupe = groupe;
    }

    public getGroupeId(): number {
        return this.groupeId;
    }

    public setGroupeId(groupeId: number): void {
        this.groupeId = groupeId;
    }


    public getInscription_id(): number {
        return this.inscription_id;
    }

    public setInscription_id(inscription_id: number): void {
        this.inscription_id = inscription_id;
    }


    public getMedecin(): MedecinDocument {
        return this.memdb.findOne({
            doctype: "MedecinDocument",
            fkey: "id",
            fvalue: this.medecin_id
        });
    }

    public getPhotodata(): string {
        return this.photodata;
    }

    public setPhotodata(photodata: string): void {
        this.photodata = photodata;
    }
    
    public setCustomDateTime(dateTime: string): void {
        this.customDateTime = dateTime;
    }


    public getListeParents(): Array<Parent> {
        let listParentsFinal: Array<Parent> = [];
        let listParents: Array<Parent> = this.memdb.find({
            doctype: "ParentDocument",
            fkey: "famille_id",
            fvalue: this.famille_id
        });


        listParents.forEach((parent: Parent) => {
            parent.getAdresse();
            parent.getLienParentIndividu(this.id);
            listParentsFinal.push(parent);
        });

        let listLien: Array<LienIndParDocument> = this.memdb.find({
            doctype: "LienIndParDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
        listLien = listLien.filter((lien: LienIndParDocument) => !listParents.some((p: Parent) => p.getId() === lien.getParent_id()))
        listLien.forEach((lien: LienIndParDocument) => {
            let parent = lien.getParent();
            if (typeof parent !== 'undefined') {
                parent.setIsAutoriser(lien.isAutorisation());
                parent.setLien(lien.getLabelLien().getLien());
                listParentsFinal.push(parent);
            }
        });
        return listParentsFinal.sort(((a: Parent, b: Parent) =>
            new Intl.Collator('fr', { usage: "sort" }).compare(a.getNom(), b.getNom())));
    }

    public getListeMaladies(): Array<MaladieDocument> {
        let listIndMaladie: Array<IndividuMaladieDocument> = this.memdb.find({
            doctype: "IndividuMaladieDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
        return listIndMaladie
            .map((indMaladie: IndividuMaladieDocument) => indMaladie.getMaladie())
            .sort((a: MaladieDocument, b: MaladieDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getLibelle(), b.getLibelle()));
    }



    public getListeAllgeries(): Array<AllergieDocument> {
        let listIndAllergie: Array<IndividuAllergieDocument> = this.memdb.find({
            doctype: "IndividuAllergieDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
        return listIndAllergie
            .map((indAllergie: IndividuAllergieDocument) => indAllergie.getAllergie())
            .sort((a: AllergieDocument, b: AllergieDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getLibelle(), b.getLibelle()));
    }

    public getListeVaccins(): Array<VaccinDocument> {
        let listIndVaccin: Array<IndividuVaccinDocument> = this.memdb.find({
            doctype: "IndividuVaccinDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
        return listIndVaccin
            .map((indVaccin: IndividuVaccinDocument) => indVaccin.getVaccin())
            .sort((a: VaccinDocument, b: VaccinDocument) =>
                new Intl.Collator('fr', { usage: "sort" }).compare(a.getLibelle(), b.getLibelle()));
    }

    public getInformationIndividu(): Array<InformationIndividuDocument> {
        return this.memdb.find({
            doctype: "InformationIndividuDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
    }

    public getListeChampsFamilles(): Array<ChampLibreResultDocument> {
        let listChampsFamilles: Array<ChampLibreResultDocument> = [];
        let listFamChampLibreResultat: Array<FamilleChampLibreResultDocument> = this.memdb.find({
            doctype: "FamilleChampLibreResultDocument",
            fkey: "infa_famille_id",
            fvalue: this.famille_id
        });
        listFamChampLibreResultat.forEach((famChampLibreResultat: FamilleChampLibreResultDocument) => {
            listChampsFamilles.push(famChampLibreResultat.getChampLibreResultDocument())
        });
        return listChampsFamilles;
    }

    public getListeChampsIndividu(): Array<ChampLibreResultDocument> {
        let listChampsIndividus: Array<ChampLibreResultDocument> = [];
        let listIndChampLibreResultat: Array<IndividuChampLibreResultDocument> = this.memdb.find({
            doctype: "IndividuChampLibreResultDocument",
            fkey: "infa_individu_id",
            fvalue: this.id
        });
        listIndChampLibreResultat.forEach((indChampLibreResultat: IndividuChampLibreResultDocument) => {
            listChampsIndividus.push(indChampLibreResultat.getChampLibreResultDocument())
        });
        return listChampsIndividus;
    }

    public getChampsLibres(): Array<ChampLibreDocument> {
        return this.memdb.findAll({
            doctype: "ChampLibreDocument"
        });
    }


    public getChampLibreValeur(): Array<ChampLibreValeurDocument> {
        return this.memdb.findAll({
            doctype: "ChampLibreValeurDocument"
        });
    }

    public getChampLibreResultValeur(): Array<ChampLibreResultValeurDocument> {
        return this.memdb.findAll({
            doctype: "ChampLibreResultValeurDocument"
        });
    }


    public getListeAutorisations(): Array<Autorisations> {
        return this.listeAutorisations;
    }

    public setListeAutorisations(listeAutorisations: Array<Autorisations>): void {
        this.listeAutorisations = listeAutorisations;
    }

    public getRegimeAlimentaireIndividu(): VieQuotidienneDocuments {
        try {
            return this.memdb.findOne({
                doctype: "VieQuotidienneDocument",
                fkey: "id",
                fvalue: this.regimealimentaire_id
            })
        } catch (error) {
            console.warn(`Impossibe de récup le régime alimentaire de ${this.displayName}`);
            return new VieQuotidienneDocuments({
                _id: 'VieQuotidienneDocuments_-99',
                id: -99,
                intitule: 'Introuvable',
                dtype: 'RegimeAlimentaire',
                defaut: true
            });
        }
    }

    public getAutori(etablissementId: number): Array<Autorisations> {
        let listAutoris: Array<Autorisations> = [];
        let autorisationsIndividu: Array<AutorisationsIndividu> = this.memdb.find({
            doctype: "AutorisationsIndividuDocument",
            fkey: "individu_id",
            fvalue: this.id
        });

        let autorisationEtablissement: Array<AutorisationEtablissement> = this.memdb.find({
            doctype: "AutorisationEtablissementDocument",
            fkey: "etablissementautorise_id",
            fvalue: etablissementId
        });
        let autoEtabIds = autorisationEtablissement.map(((autoEtab: AutorisationEtablissement) => autoEtab.getAutorisation_id()));

        autorisationsIndividu = autorisationsIndividu.filter(((autoInd: AutorisationsIndividu) => autoEtabIds.includes(autoInd.getAutorisation_id())));

        autorisationsIndividu.forEach((autoInd: AutorisationsIndividu) => {
            let a = autoInd.getAutorisation();
            let autorisation = new Autorisations(a);
            autorisation.setAffichageedition(autoInd.getAffichageedition());
            listAutoris.push(autorisation);
        });

        return listAutoris;
    }

    public getInscriptions(): Array<Inscription> {
        return this.memdb.find({
            doctype: "InscriptionDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
    }

    public getInscriptionActivite(activite_id: number): Inscription | undefined {
        let listInscriptions = this.memdb.find({
            doctype: "InscriptionDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
        let inscrip = listInscriptions.find((inscri: Inscription) => {
            if (inscri.getActivite_id() === activite_id) {
                return inscri
            }
        })
        this.setInscription_id(inscrip.getId);
        return inscrip;
    }

    public getFamilleInfos() : Famille | undefined{
        return this.memdb.findOne({
            doctype:"FamilleDocument",
            fkey:"id",
            fvalue:this.famille_id
        })
    }

    public getPortable(): string {
        return this.portable;
    }

    public setPortable(portable: string): void {
        this.portable = portable;
    }

    public getEmail(): string {
        return this.email;
    }

    public setEmail(email: string): void {
        this.email = email;
    }

    public getHistoScolariteIndividu(): Array<HistoScolarite> {
        return this.memdb.find({
            doctype: "HistoScolariteIndividuDocument",
            fkey: "individu_id",
            fvalue: this.id
        });
    }

    public getPointages():Array<String>{
         return this.pointages;
    }
    public setPointages(val:Array<String>):void{  
        if(this.pointages!=null)
        this.pointages.splice(0);
        this.pointages.push(...val);
    }
    public getEtime(){
        return this.etime;
    }
    public setEtime(val:number){
        this.etime=val;
    }


}
